import React from 'react'
import { edit_admin_move_mode_path } from '../../../routes'
import { t } from '../../i18n'
import { ServoMoveStepUsage } from './models'

interface UsagePanelProps {
  usage: ServoMoveStepUsage
}

const UsagePanel: React.FC<UsagePanelProps> = ({ usage }) => (
  <div className="card card-robis usage-panel">
    <div className="usage-panel__label">{t('servo_move_steps.usage.title')}</div>
    <div className="usage-panel__summary">
      {t('servo_move_steps.usage.summary', {
        move_modes: t('servo_move_steps.usage.move_mode_count', { count: usage.move_mode_count }),
        meals: t('servo_move_steps.usage.prepared_count', { count: usage.prepared_count }),
      })}
    </div>
    {usage.move_modes.length === 0 ? (
      <p className="usage-panel__empty">{t('servo_move_steps.usage.empty')}</p>
    ) : (
      <ul className="usage-panel__list">
        {usage.move_modes.map((row) => (
          <li key={row.move_mode_id} className="usage-panel__row usage-panel__row--stacked">
            <a href={edit_admin_move_mode_path(row.move_mode_id)}>{row.move_mode_name}</a>
            <span className="usage-panel__meta">
              {t('servo_move_steps.usage.move_mode_counts', {
                recipes: t('servo_move_steps.usage.row_recipe_count', { count: row.recipe_count }),
                prepared: t('servo_move_steps.usage.row_prepared_count', { count: row.prepared_count }),
              })}
            </span>
          </li>
        ))}
      </ul>
    )}
  </div>
)

export default UsagePanel
